import { render, staticRenderFns } from "./VerificationEmailModal.vue?vue&type=template&id=95a99242"
import script from "./VerificationEmailModal.vue?vue&type=script&lang=js"
export * from "./VerificationEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports